<div class="moorl-media-gallery">
    <sw-upload-listener
        v-if="!isLoading"
        :upload-tag="currentItem.id"
        auto-upload
        @media-upload-finish="successfulUpload"
        @media-upload-fail="onUploadFailed"
    />
    <sw-media-upload-v2
        v-if="!isLoading"
        :upload-tag="currentItem.id"
        :scroll-target="$parent.$el"
        :default-folder="defaultFolder"
        @media-upload-sidebar-open="onOpenMediaModal"
    />
    <div class="moorl-media-gallery__previews">
        <div
            class="moorl-media-gallery__cover-container moorl-media-gallery__column"
        >
            <div
                v-if="currentItem.cover || cover"
                class="moorl-media-gallery__preview-cover"
            >
                <div class="preview-cover">
                    <sw-media-preview-v2
                        class="moorl-media-gallery__cover-image"
                        :source="cover ? cover.mediaId : currentItem.cover.mediaId"
                    />
                    <span>
                        {{ $tc('sw-product.mediaForm.coverSubline') }}
                    </span>
                </div>
            </div>
            <div
                v-else
                class="moorl-media-gallery__cover-image is--placeholder"
            >
                {{ $tc('sw-product.mediaForm.coverSubline') }}
            </div>
        </div>
        <div
            v-if="!isLoading"
            class="moorl-media-gallery__grid moorl-media-gallery__column"
            :style="gridAutoRows"
        >
            <sw-product-image
                v-for="mediaItem in mediaItems"
                :key="mediaItem.id"
                v-draggable="{ dragGroup: 'ad-media', data: mediaItem, onDragEnter: onMediaItemDragSort }"
                v-droppable="{ dragGroup: 'ad-media', data: mediaItem }"
                :is-cover="isCover(mediaItem)"
                :is-placeholder="mediaItem.isPlaceholder"
                :media-id="mediaItem.mediaId"
                :show-cover-label="showCoverLabel"
                @sw-product-image-delete="removeFile(mediaItem)"
                @sw-product-image-cover="markMediaAsCover(mediaItem)"
            />
        </div>
        <mt-loader v-else/>
    </div>
    <sw-media-modal-v2
        v-if="showMediaModal"
        entity-context="entity"
        @media-modal-selection-change="onAddMedia"
        @modal-close="onCloseMediaModal"
    />
</div>